import React from 'react';
import ConcentricCircles from './ConcentricCircles';
import DrawTool from './DrawTool';
import FillEdges from './FillEdges';
import BWHalftone from './BWHalftone';  // 引入 Tool04 (B&W Halftone) 组件

const DrawingArea = ({ selectedTool, toolProps, drawToolRef, fillEdgesRef }) => {
  return (
    <div className="drawing-area">
      {selectedTool === 'tool01' && (
        <ConcentricCircles
          circleCount={toolProps.circleCount}
          minRadius={toolProps.minRadius}
          spacing={toolProps.spacing}
          baseFontSize={toolProps.baseFontSize}
          fontSizeDecreaseFactor={toolProps.fontSizeDecreaseFactor}
          fontWeight={toolProps.fontWeight}
          colors={toolProps.colors}
          svgWidth={toolProps.svgWidth}
          svgHeight={toolProps.svgHeight}
          downloadSVG={toolProps.downloadConcentricSVG}  // 确保传递了下载SVG的方法
        />
      )}

      {selectedTool === 'tool02' && (
        <DrawTool
          ref={drawToolRef}  // 传递 ref
          svgWidth={toolProps.svgWidth}
          svgHeight={toolProps.svgHeight}
          clearPaths={toolProps.clearPaths}  // 确保传递了clearPaths的方法
          downloadSVG={toolProps.downloadDrawToolSVG}  // 确保传递了下载SVG的方法
        />
      )}

      {selectedTool === 'tool03' && (
        <FillEdges
          ref={fillEdgesRef}
          imageWidth={toolProps.fillEdgesImageWidth}
          imageHeight={toolProps.fillEdgesImageHeight}
          fillColor={toolProps.fillEdgesFillColor}
          strokeColor={toolProps.fillEdgesStrokeColor}
          strokeWidth={toolProps.fillEdgesStrokeWidth}
          backgroundThreshold={toolProps.fillEdgesBackgroundThreshold}
          backgroundColor={toolProps.fillEdgesBackgroundColor}
          aColor={toolProps.aColor}
          aAngle={toolProps.aAngle}
          aThickness={toolProps.aThickness}
          aSpacing={toolProps.aSpacing}
          bColor={toolProps.bColor}
          bAngle={toolProps.bAngle}
          bThickness={toolProps.bThickness}
          bSpacing={toolProps.bSpacing}
          downloadSVG={toolProps.downloadFillEdgesSVG}
        />
      )}

      {selectedTool === 'tool04' && (  // 添加 Tool04 (B&W Halftone) 的渲染逻辑
        <BWHalftone
          image={toolProps.image}
          halftoneDotSize={toolProps.halftoneDotSize}
          brightnessThreshold={toolProps.brightnessThreshold}
          dotSpacing={toolProps.dotSpacing}
          dotColor={toolProps.dotColor}
          scale={toolProps.scale}
          downloadSVG={toolProps.downloadHalftoneSVG}  // 确保传递了下载SVG的方法
        />
      )}
    </div>
  );
};

export default DrawingArea;
